import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToClaimOrigin = mapDictionaryState;

const claimOrigin = createDictionaryApiFactory("claimOrigin");

export const getClaimOrigin = claimOrigin.search;
export const getClaimOriginDetail = claimOrigin.getDetail;
export const createClaimOrigin = claimOrigin.save;
export const exportCsvClaimOrigin = claimOrigin.exportCsv;
export const getClaimOriginOptions = claimOrigin.getSelectOptions;
